<template>
    <div>
        <rkm-area
            title="Resultados de exames"
            type="fieldset"
        >

            <rkm-row v-if="data.additionals.exibeBoxExameLaboratorialSolicitado">
                <rkm-col cols="12">
                    <rkm-area
                        :closed="!readonly"
                        background-color="primary"
                        title="Exames realizados"
                        type="box"
                        no-margin-top
                    >
                        <BoxExameAvaliado :data="data" />
                    </rkm-area>
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="data.additionals.exibeBoxExameLaboratorialSolicitado && data.additionals.paciente.sexoId == enums.sexo.FEMININO">
                <rkm-col cols="12">
                    <rkm-area
                        :closed="!readonly"
                        background-color="primary"
                        title="Triagem neonatal"
                        type="box"
                    >
                        <BoxTriagemNeoNatal :data="data" />
                    </rkm-area>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-area
                        title="Outros exames"
                    >

                        <template
                            v-if="!readonly"
                            slot="trailing"
                        >
                            <rkm-button
                                @click="$refs.Modal.open()"
                                color="primary"
                                small
                                title="Adicionar"
                            >
                                <rkm-icon icon="plus" />
                            </rkm-button>
                        </template>

                        <List
                            :data="data"
                            :readonly="readonly"
                        />
                    </rkm-area>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import List from './List'
import Modal from './Modal'
import BoxExameAvaliado from './components/exame-avaliado/Index'
import BoxTriagemNeoNatal from './components/triagem-neonatal/Index'

// Enums.
import sexo from '@/enums/cadastro/cidadao/sexo'

export default {
    components: {
        List,
        Modal,
        BoxExameAvaliado,
        BoxTriagemNeoNatal,
    },
    data: () => ({
        enums: {sexo},
    }),
    props: {
        data: {type: Object, required: true},
        readonly: {type: Boolean, default: false},
    },
}
</script>